import {
    Chip,
    DialogContent,
    DialogTitle,
    ToggleButton,
    ToggleButtonGroup
} from "@mui/material";
import {Dialog2} from "../../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../../misc/SmoothActionBar";
import React, {useContext, useState} from "react";
import {AddItem} from "../../freeformchanges/products/add/AddHardware";
import {EditContext} from "../../../../../misc/scroller/EditProvider";
import {DimensionedExtras, MiscProduct} from "../../../../../api/MiscProducts";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../../misc/SyncedRef";
import {useAlternative} from "../../../quote/alternative/Alternative";
import {useProjectId} from "../../ProjectName";

export function AddItemDialog(props: {
    onDone(): void;
}) {
    const ctx = useContext(EditContext);
    const [value, setValue] = useState<Partial<MiscProduct & DimensionedExtras>>();
    const updateRef = useSyncedRef(ctx.update);
    const onDoneRef = useSyncedRef(props.onDone);

    const add = useAsyncAction(async (input: {
        value: MiscProduct
    }) => {
        await updateRef.current(input.value);
        onDoneRef.current();
    }, []);

    const projectId = useProjectId();
    const alt = useAlternative();

    const [category, setCategory] = useState("hardware");

    const submit = () => {
        if(!value) return;
        add.callback({
            value: value as any,
        })
    };

    return (
        <Dialog2 open onClose={() => props.onDone()} maxWidth="md" fullWidth onEnterPress={submit}>

            <DialogTitle>Add Item</DialogTitle>

            <DialogContent>
                <div style={{height: 8}} />

                <ToggleButtonGroup size="small" exclusive value={category} onChange={(e, v) => setCategory(v || "hardware")}>
                    <ToggleButton value="hardware">Hardware</ToggleButton>
                    <ToggleButton value="frame-anchor">Anchors</ToggleButton>
                    <ToggleButton value="manufacture">Components</ToggleButton>
                </ToggleButtonGroup>

                <div style={{height: 8}} />

                {value && (
                    <div style={{
                        marginBottom: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: 8,
                    }}>
                        <Chip
                            label={value.categoryName + ": " + value.productCode + " from " + value.manufacturerName} variant="outlined"
                             onDelete={() => setValue(undefined)}
                        />

                        <>
                            {value.extras && (
                                <div style={{
                                    fontSize: "0.8rem",
                                    paddingLeft: "1rem",
                                }}>
                                    {value.extras.dimHeight && <div>Height: {value.extras.dimHeight}</div>}
                                    {value.extras.dimWidth && <div>Width: {value.extras.dimWidth}</div>}
                                    {value.extras.dimLength && <div>Length: {value.extras.dimLength}</div>}
                                    {value.extras.handing && <div>Handing: {value.extras.handing}</div>}
                                </div>
                            )}
                        </>
                    </div>
                )}
                {!value && <AddItem kind={category as any} onAdd={(v, extra) => {

                    setValue({
                        project: projectId,
                        quoteAlternative: alt,

                        product: v.id,

                        productCode: v.productCode,
                        categoryName: v.categoryName,
                        manufacturer: v.manufacturer,
                        manufacturerName: v.manufacturerName,

                        extras: {
                            dimHeight: v.dimHeight,
                            dimWidth: v.dimWidth,
                            dimLength: v.dimLength,
                            handing: extra.handing || "",
                            manualScriptInputs: extra.scriptInputs,
                        },

                        qty: 1,
                        updatedAt: new Date().toISOString(),
                        archived: false,
                    });
                }}/>}
            </DialogContent>

            <SmoothActionBar
                loading={add.loading}
                error={add.error}
                onCancel={() => props.onDone()}
                submitDisabled={!value}
                actionName="Add"
                onSubmit={submit}
            />
        </Dialog2>
    )
}